import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.svelte';

var app = new App({
	target: document.body
});

export default app;